<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
	name: 'App',
	created () {
		document.title = "Sistema de Matrícula";
	}
}
</script>
